import { Checkbox as AntdCheckbox, type CheckboxProps as AntdCheckboxProps } from "antd";

import type { AvE2EProps } from "../types";

export type CheckboxProps = AntdCheckboxProps & AvE2EProps;

function CustomCheckbox(props: CheckboxProps) {
  const { testIdPrefix, ...restProps } = props;

  return <AntdCheckbox data-testid={`${testIdPrefix}-checkbox`} {...restProps} />;
}

export const Checkbox = Object.assign(CustomCheckbox, {
  Group: AntdCheckbox.Group,
});
